<template>
    <div class="layout-footer">
        <img src="/logo.png" alt="Logo" height="20" class="mr-2" />
        <span class="font-medium ml-2">Copia e Cola</span>
        <span class="font-small ml-2">v1.0.0</span>
    </div>
</template>
<style lang="scss" scoped></style>
